<template>
    <div id="app" class="layout--default">
        <Sidebar />
        <HeaderMobile />

        <main :class="{ 'dlbar--active' : showDownloadBar }">
            <Header />
            <transition name="fade-in" mode="out-in">
                <router-view :key="$route.params.child || $route.params.page || $route.name" />
            </transition>

            <transition name="fade-up-down" mode="out-in">
                <div class="dlbar" v-if="showDownloadBar">
                    <Button
                        :class="['dlbar--btn',
                            { 'btn--loading' : zipLoading },
                            { 'btn--success' : zipSuccess }
                        ]"
                        :disabled="zipLoading || zipSuccess"
                        @click="generateZip"
                    >
                        <template v-if="!zipLoading && !zipSuccess && !zipError">
                            <SVGicon-download /> {{ zipCount }} {{ zipCount > 1 ? 'files' : 'file' }}
                        </template>

                        <template v-if="zipLoading">
                            Zipping {{ zipCount }} {{ zipCount > 1 ? 'files' : 'file' }} <Spinner />
                        </template>

                        <template v-if="zipSuccess">
                            Zipped! Prompting to save...
                        </template>

                        <template v-if="zipError">
                            Error - try again?
                        </template>
                    </Button>

                    <Button display="link" class="dlbar__cancel" @click="clearZipSelections">
                        Clear Selections
                    </Button>
                </div>
            </transition>

            <FooterCopyright />

            <NavMobile @toggleNav="mobNavOpen = !mobNavOpen" :mobNavOpen="mobNavOpen" />
            <transition name="fade-in-nav" mode="out-in">
                <NavModal v-if="mobNavOpen" @toggleNav="mobNavOpen = !mobNavOpen" @closeMobNav="mobNavOpen = false"/>
            </transition>

            <Modal
                class="auto-width"
                @close="closeVideo"
                v-if="videoModalOpen"
            >
                <div class="video" :key="`video-modal-${videoURL.id}`">
                    <iframe
                        :src="`${baseVideoURL}${videoURL.id}`"
                        frameborder="0"
                        allowfullscreen="true"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        width="700"
                        height="393.75"
                    />
                </div>
            </Modal>

            <transition name="slide-in-right" mode="out-in">
                <EditResourcePanel v-if="editingResource" />
            </transition>

            <BackToTop />
        </main>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            zipLoading: false,
            zipSuccess: false,
            zipError: false,
            mobNavOpen: false,
        }
    },

    computed: {
        ...mapState('Resources', ['zipFiles', 'videoModalOpen', 'videoURL', 'editingResource']),

        zipCount () { return this.zipFiles.length },
        showDownloadBar () { return this.zipCount > 0 },
        baseVideoURL () {
            return this.videoURL.type === 'youtube'
                ? 'https://www.youtube.com/embed/'
                : 'https://player.vimeo.com/video/'
        }
    },

    created () {
        this.getAllAreas()
    },

    methods: {
        ...mapActions('Resources', ['clearZipSelections', 'getAllAreas', 'closeVideo']),

        async generateZip () {
            this.zipLoading = true
            this.zipError = null
            this.zipSuccess = false

            const files = this.zipFiles.reduce((acc, file) => {
                return [...acc, {
                    title: file.name,
                    filename: file.filename,
                    area: file.area,
                    category: file.category,
                    group: file.group
                }]
            }, [])

            this.axios.post('/download', { download: { files } })
                .then(({ data }) => {
                    if (data.status !== 'success') throw new Error("Sorry, we couldn't zip your files.")

                    this.zipSuccess = true

                    setTimeout(() => {
                        window.open(data.zip, '_blank')
                        this.zipSuccess = false
                        this.clearZipSelections()
                    }, 1500);
                })
                .catch(err => console.log(err))
                .finally(() => this.zipLoading = false)
        }
    }
}
</script>
